import { useState } from "react";
import { manualTabs, manualContents } from "@/mocks/home";

export default function DigitalManual() {
  const [active, setActive] = useState("intro");
  const content = manualContents[active];

  return (
    <section id="manual" className="w-full bg-background-50 py-14 md:py-24">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
          <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
            OFFICIAL USER GUIDE
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight break-keep">
            X9 PRO 디지털 제품 설명서
          </h2>
          <p className="mt-4 text-foreground-700 leading-relaxed">
            동봉된 공식 지면 설명서 내용을 편리하게 탐색해볼 수 있는 가이드입니다.
          </p>
        </div>

        <div className="flex flex-col items-center md:flex-row md:flex-wrap md:justify-center gap-2 md:gap-3 mb-10">
          {manualTabs.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setActive(t.id)}
              className={`w-full max-w-[260px] md:w-auto md:max-w-none min-h-11 px-4 py-2.5 rounded-full text-xs font-semibold tracking-wide transition-all cursor-pointer whitespace-nowrap ${
                active === t.id
                  ? "bg-foreground-950 text-background-50 shadow-md"
                  : "bg-background-100 text-foreground-700 hover:text-foreground-950 border border-background-200/70"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="rounded-2xl bg-background-50 border border-background-200/70 p-5 md:p-10 shadow-sm">
          <div>
            <div className="space-y-6">
              <div>
                <span className="inline-block text-[10px] font-heading font-bold text-primary-600 bg-primary-100 px-2.5 py-1 rounded-md uppercase tracking-wider mb-3">
                  {manualTabs.find((t) => t.id === active)?.label}
                </span>
                <h3 className="font-heading text-xl sm:text-2xl md:text-3xl font-bold text-foreground-950 leading-tight break-keep">
                  {content.title}
                </h3>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {content.body}
              </p>
              {content.bullets && (
                <div className="border-t border-background-200/70 pt-6">
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {content.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-start gap-2.5 text-xs text-foreground-800 bg-background-100 border border-background-200/50 px-4 py-3 rounded-xl"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-1.5 shrink-0"></span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
